module.exports = __webpack_public_path__ + "static/media/header.062e5fc1.png";